/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsBaseballIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-baseball"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.38 18.5Q2.33 17.07 1.76 15.43Q1.2 13.78 1.2 12Q1.2 10.22 1.76 8.57Q2.33 6.92 3.38 5.5Q4.9 6.7 5.76 8.39Q6.63 10.07 6.63 12Q6.63 13.93 5.76 15.61Q4.9 17.3 3.38 18.5ZM12 22.8Q12 22.8 11.06 22.8Q10.13 22.8 8.4 22.2Q6.67 21.6 5.25 20.43Q7.15 18.88 8.21 16.68Q9.28 14.47 9.28 12Q9.28 9.53 8.21 7.33Q7.15 5.13 5.25 3.58Q6.67 2.4 8.4 1.8Q10.13 1.2 12 1.2Q13.88 1.2 15.6 1.8Q17.32 2.4 18.75 3.58Q16.85 5.13 15.79 7.33Q14.72 9.53 14.72 12Q14.72 14.47 15.79 16.68Q16.85 18.88 18.75 20.43Q17.32 21.6 15.6 22.2Q13.88 22.8 12 22.8ZM20.63 18.5Q19.1 17.3 18.24 15.61Q17.38 13.93 17.38 12Q17.38 10.07 18.24 8.39Q19.1 6.7 20.63 5.5Q21.68 6.92 22.24 8.57Q22.8 10.22 22.8 12Q22.8 13.78 22.24 15.43Q21.68 17.07 20.63 18.5Z" fill={color} />
    </svg>
  );
}
